import React, { useState } from 'react';
import { useParams } from 'react-router-dom';
import DayComponent from 'src/components/prepare/DayComponent';
import Container from 'src/components/shared/Container';
import { useUserContext } from 'src/context/UserProvider';
import { useGetPrepePlanById } from 'src/hooks/prepPlan.hooks';
import { DailyPlanFormat, PrepPlanBadgeStatus, UIPrepPlan } from 'types';
import seoConfig from '../seo.json';
import Seo from 'src/components/Seo';
import ChallengeBanner from 'src/components/challenges/ChallengeBanner';
import ChallengeDifficulty from 'src/components/prepare/ChallengeDifficulty';
import OtherChallenges from 'src/components/prepare/OtherChallenges';

const Challenge = () => {
	const { isJobseekerLoggedIn } = useUserContext();
	const { challengeId } = useParams();

	const [prepData, setPrepData] = useState<DailyPlanFormat[]>([]);
	const [progress, setProgress] = useState<number>(0);
	const seoInfo = seoConfig['prep'];
	const [prepPlan, setPrepPlan] = useState<UIPrepPlan>();

	useGetPrepePlanById({
		isJobSeekerLoggedIn: isJobseekerLoggedIn,
		id: challengeId || '',
		onComplete: data => {
			const prepDataFormatted = data.prepPlan?.dayWisePerformance.map(day => ({
				day: day.day,
				status: day.isLocked
					? PrepPlanBadgeStatus.LOCKED
					: day.isCompleted
					  ? PrepPlanBadgeStatus.COMPLETED
					  : PrepPlanBadgeStatus.IN_PROGRESS,
				questions: day.performance
					.map(per => per.questionWisePerformance.flat())
					.flat()
					?.map(question => {
						const totalUsersAttempted = data.allAssessQuestionIdsCount?.find(
							item => item?._id === question?.assessQuestionId,
						)?.count;
						return {
							...question,
							totalUsersAttempted: totalUsersAttempted,
						};
					}),
			}));

			setProgress(data.percentCompleted || 0);
			setPrepPlan(data.prepPlan);
			if (prepDataFormatted) setPrepData(prepDataFormatted);
		},
	});
	return (
		<>
			<Seo title={seoInfo.title} description={seoInfo.title} />
			{prepPlan && (
				<Container>
					<ChallengeBanner progress={progress} prepPlan={prepPlan} numberOfDays={prepData.length ?? 0} />
					<div className="grid md:flex gap-0 md:gap-[36px] ">
						<DayComponent dailyPlan={prepData} />
						<div className="mt-[24px] md:mt-[48px] flex flex-col gap-[36px]">
							<div>
								<ChallengeDifficulty prepPlan={prepPlan} />
							</div>
							<div>
								<OtherChallenges prepPlan={prepPlan} />
							</div>
						</div>
					</div>
				</Container>
			)}
		</>
	);
};

export default Challenge;
